import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  border-left: 1px solid ${({ theme }) => theme.colors.PRODUCT.SECONDARY_BORDER};
  border-right: 1px solid ${({ theme }) => theme.colors.PRODUCT.SECONDARY_BORDER};
  padding: .5em 2em 1em 1em;
`;
